import { createTheme, MantineColorsTuple } from "@mantine/core"
import { ConfirmModal } from "@mantine/modals/lib/ConfirmModal"

const grayColors: MantineColorsTuple = [
  "#f7f7f7",
  "#f5f5f5",
  "#e7e7e7",
  "#cdcdcd",
  "#b2b2b2",
  "#9a9a9a",
  "#8b8b8b",
  "#848484",
  "#717171",
  "#656565",
  "#575757",
]

const blueColor: MantineColorsTuple = [
  "#e4f4ff",
  "#cde4ff",
  "#9ac6ff",
  "#64a6ff",
  "#398bfe",
  "#1d7afe",
  "#0971ff",
  "#0060e4",
  "#0055cd",
  "#0049b5",
]

export const mantineTheme = createTheme({
  /** Your theme override here */
  fontFamily: "var(--font-family-system)",
  // focusRing: "auto",
  // radius: {
  //   md: "px",
  // },
  // fontSizes: {
  //   md: "14px",
  // },
  colors: {
    gray: grayColors,
    blue: blueColor,
  },
  // defaultRadius: "md",
  components: {
    TextInput: {
      styles: (theme, params) => ({
        input: params.size === "md" ? { height: "44px" } : {},
      }),
    },
  },
})
